<template>
  <div class="container">
    <div class="school-body-index-teacher">
      <el-form :inline="true" size="small" @submit.native.prevent>
        <el-form-item label="班级名称:">
          <el-input clearable style="width: 200px" v-model="form.className" placeholder="请输入班级名称" @keyup.enter.native="search2" @change="search2"></el-input>
        </el-form-item>

        <el-form-item label="讲次名称:">
          <el-input clearable style="width: 200px" v-model="form.lesson_title" placeholder="请输入讲次" @keyup.enter.native="search2" @change="search2"></el-input>
        </el-form-item>

        <el-form-item label="上课时间:">
          <el-date-picker style="width:300px;" :picker-options="pickerOptions" v-model="form.time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" @change="search2" placement="bottom-start">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="search2" icon="el-icon-search">查询</el-button>
        </el-form-item>

        <!-- <el-form-item label="点名时间:">
          <el-date-picker :picker-options="pickerOptions" v-model="form.sigin_time" type="daterange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']" @change="search2">
          </el-date-picker>
        </el-form-item> -->
      </el-form>

      <div class="table-style">
        <el-table size="small" :data="tableData" :header-cell-style="{
            background: '#f5f7fa',
            color: '#606266',
            'font-size': '14px',
          }" stripe>
          <el-table-column align="center" width="50" label="序号">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 + (page_no - 1) * page_size }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="className" label="班级名称" width="200">
          </el-table-column>

          <el-table-column prop="lessonTitle" label="讲次名称">
          </el-table-column>

          <el-table-column prop="tchPlanSignData1" label="上课时间" width="200">
            <template slot-scope="scope">
              <span v-if="scope.row.start_class_date">{{ scope.row.start_class_date.slice(0, 16) }} -
                {{ scope.row.end_class_date.slice(10, 16) }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="" align="center" label="实到/应到">
            <template slot-scope="scope">
              <span style="color:#333;">{{ scope.row.stuSignNum }} /
                {{ scope.row.stuTotalSignNum }}</span>
            </template>
          </el-table-column>

          <!-- <el-table-column prop="tchPlanSignData" label="点名时间">
          </el-table-column> -->
          <el-table-column align="center" label="课堂作品">
            <template slot-scope="scope">
              <span style="color:#333;">{{ scope.row.classworkFinishNum }} /
                {{ scope.row.stuSignNum }}</span>

              <!-- <span  v-if="scope.row.classWorkState == true" style="color:#008000">已提交</span>
                             <span v-else style="color:#FF0000">未提交</span> -->
            </template>
          </el-table-column>
          <el-table-column align="center" label="作业">
            <template slot-scope="scope">
              <span style="color:#333;">{{ scope.row.homeworkFinishNum }} /
                {{ scope.row.stuSignNum }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="" align="center" label="已评价">
            <template slot-scope="scope">
              <span style="color:#333;">{{ scope.row.evaluateStuNum }} /
                {{ scope.row.stuSignNum }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="" label="操作" fixed="right" width="100">
            <template slot-scope="scope">
              <el-button v-if="scope.row.evaluateStuNum !== scope.row.stuTotalSignNum" type="text" @click="goNext(scope.row)" size="mini">去点评</el-button>

              <el-button style="color:grey;" v-else type="text" @click="goNext(scope.row)" size="mini">已完成</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-style">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page_no" :page-sizes="[10, 15, 20, 30, 40, 50, 100]" :page-size="page_size" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getTchPlanListForEvaluate } from '@/api/educational.js'
import moment from 'moment'
export default {
  name: 'works',
  data() {
    return {
      form: {},
      tableData: [],

      pickerOptions: {
        shortcuts: [
          {
            text: '今日',
            onClick(picker) {
              const start = moment().format('YYYY-MM-DD 00:00:00')
              const end = moment().format('YYYY-MM-DD 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '本周',
            onClick(picker) {
              const start = moment(
                moment()
                  .week(moment().week())
                  .startOf('week')
                  .add(1, 'days')
                  .valueOf()
              ).format('YYYY-MM-DD 00:00:00')
              const end = moment(
                moment()
                  .week(moment().week())
                  .endOf('week')
                  .add(1, 'days')
                  .valueOf()
              ).format('YYYY-MM-DD 23:59:59')
              console.log(start, 1234165)
              console.log(end, 1234165)

              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '上周',
            onClick(picker) {
              const start = moment(
                moment()
                  .week(moment().week() - 1)
                  .startOf('week')
                  .valueOf()
              ).format('YYYY-MM-DD 00:00:00')
              const end = moment(
                moment()
                  .week(moment().week() - 1)
                  .endOf('week')
                  .valueOf()
              ).format('YYYY-MM-DD 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '本月',
            onClick(picker) {
              const start = moment()
                .startOf('month')
                .format('YYYY-MM-DD 00:00:00')
              const end = moment()
                .endOf('month')
                .format('YYYY-MM-DD 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '上月',
            onClick(picker) {
              const start = moment()
                .subtract(1, 'month')
                .startOf('month')
                .format('YYYY-MM-DD 00:00:00')
              const end = moment()
                .subtract(1, 'month')
                .endOf('month')
                .format('YYYY-MM-DD 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '本季度',
            onClick(picker) {
              const start = moment(
                moment()
                  .quarter(moment().quarter())
                  .startOf('quarter')
                  .valueOf()
              ).format('YYYY-MM-DD 00:00:00')
              const end = moment(
                moment()
                  .quarter(moment().quarter())
                  .endOf('quarter')
                  .valueOf()
              ).format('YYYY-MM-DD 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '上季度',
            onClick(picker) {
              const start = moment(
                moment()
                  .quarter(moment().quarter() - 1)
                  .startOf('quarter')
                  .valueOf()
              ).format('YYYY-MM-DD 00:00:00')
              const end = moment(
                moment()
                  .quarter(moment().quarter() - 1)
                  .endOf('quarter')
                  .valueOf()
              ).format('YYYY-MM-DD 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '本年',
            onClick(picker) {
              const start = moment(
                moment()
                  .year(moment().year())
                  .startOf('year')
                  .valueOf()
              ).format('YYYY-MM-DD 00:00:00')
              const end = moment(
                moment()
                  .year(moment().year())
                  .endOf('year')
                  .valueOf()
              ).format('YYYY-MM-DD 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '上年',
            onClick(picker) {
              const start = moment(
                moment()
                  .year(moment().year() - 1)
                  .startOf('year')
                  .valueOf()
              ).format('YYYY-MM-DD 00:00:00')
              const end = moment(
                moment()
                  .year(moment().year() - 1)
                  .endOf('year')
                  .valueOf()
              ).format('YYYY-MM-DD 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },

      page_no: 1,
      page_size: 20,
      total: 0,
      firstTime: true,
    }
  },

  created() { },

  mounted() {
    if (this.firstTime == true) {
      this.getTchPlanListForEvaluate()
    }
  },
  activated() {
    if (this.firstTime === false) {
      this.getTchPlanListForEvaluate()
    }
  },

  methods: {
    search2() {
      this.page_no = 1
      this.getTchPlanListForEvaluate()
    },
    getTchPlanListForEvaluate() {
      getTchPlanListForEvaluate({
        className: this.form.className,
        lesson_title: this.form.lesson_title,
        class_start_date: this.form.time ? this.form.time[0] : '',
        class_end_date: this.form.time ? this.form.time[1] : '',
        start_date: this.form.sigin_time ? this.form.sigin_time[0] : '',
        end_date: this.form.sigin_time ? this.form.sigin_time[1] : '',
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log(res, 123465)
        this.tableData = res.returnDataArr
        this.total = res.total
      })
    },
    handleSizeChange(val) {
      this.page_size = val
      this.getTchPlanListForEvaluate()
    },
    handleCurrentChange(val) {
      this.page_no = val
      this.getTchPlanListForEvaluate()
    },
    goNext(row) {
      this.firstTime = false
      console.log(row, 123456)
      sessionStorage.setItem('workInfo', JSON.stringify(row))
      this.$router.push({
        name: 'worksDetails',
        query: {
          teachingPlanId: row.tchPlanId,
          subjectCode: row.subjectCode,
          lessonId: row.lessonId,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
// /deep/.el-table__body tr.current-row>td{
//     background-color: #E1EDFF !important;
// }
.school-body-index-teacher {
  background: white;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  border-radius: 5px;
  margin: 10px;

  .classwrapper {
    background: white;

    .classtype {
    }

    .classlist {
      border: 1px solid rgb(226, 226, 226);
      margin: 15px;
      border-radius: 5px;
      padding-bottom: 10px;

      .class_img {
        display: block;
        width: 100%;
        height: 0;
        padding-bottom: 69%;
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 5px 5px 0px 0px;

        .classimg {
          width: 100%;

          border-radius: 5px 5px 0px 0px;
        }
      }

      .class_room {
        margin-top: 10px;

        .classname {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-weight: bold;
          padding-left: 10px;
          font-size: 16px;
        }
      }

      .class_time {
        padding-left: 10px;
        line-height: 20px;
      }

      .class_num {
        padding-left: 10px;
        line-height: 20px;
      }
    }

    .pagesdiv {
      text-align: center;
      padding: 10px;
    }
  }

  .classlist_wrapper {
    .classlist-imgwrapper {
      .classimg_wrapper_img {
        width: 100%;
        border-radius: 5px;
        margin-top: 10%;
      }
    }

    .classlist-content {
      flex: 1;
      display: flex;
      flex-flow: column;

      .classlist-content-title {
        flex: 1;

        line-height: 40px;
        padding-left: 40px;
        font-weight: 500;

        .coursetitle {
          padding-right: 10px;
          font-weight: 800;
        }
      }

      .classlist-content-desc {
        flex: 1;

        line-height: 40px;
        padding-left: 40px;

        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;

        .content-desc {
          padding-right: 20px;
        }
      }

      .classlist-content-date {
        flex: 1;

        line-height: 40px;
        padding-left: 40px;
      }
    }

    .classlist-btn {
      height: 140px;
      line-height: 140px;

      text-align: center;

      .drop_btn {
        margin-right: 20px;
        margin-top: 60px;
      }

      .class_btn {
        margin-top: 60px;
        margin-right: 20px;
      }
    }

    .pagination-style {
      margin: 20px;
    }
  }

  /*
#qrcodeImg {
  box-sizing: border-box;
  display: inline-block;
  padding: 8px;
  background: #cccccc;
  & > img {
    display: inline-block !important;
  }
}
*/
}

.txttag {
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden; //文本超出隐藏
  text-overflow: ellipsis; //文本超出省略号替代
}
</style>

<style>
.el-popover {
  background: #f5f7fa;
}

.container .el-drawer__header {
  margin-bottom: 0px;
  padding: 0px;
  font-weight: bold;
  border-bottom: 0px;
  background: #f9f9f9;
  text-align: center;
}
.edit {
  cursor: pointer;
}
.edit:hover {
  color: #409eff;
}
</style>
